// extracted by mini-css-extract-plugin
module.exports = {"bottom_menu":"BottomMenu_bottom_menu__3-c66","menu_item":"BottomMenu_menu_item__20EI6","menu_item_selected":"BottomMenu_menu_item_selected__3GyuF"};